import { render } from "./Create.vue?vue&type=template&id=8b91f0d8&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=8b91f0d8&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=8b91f0d8&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/MOTOPIRUETAS/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b91f0d8"]])

export default __exports__